/**
 * PersonDropdown Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectFertilizerProductsArray } from 'services/fertilizerProducts/selectors';
import { FertilizerProduct } from 'services/fertilizerProducts/types';

// Utils
// @ts-ignore
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOrderedData = createDeepEqualSelector(
    selectFertilizerProductsArray,
    (fertilizerProductsArray) => orderBy(fertilizerProductsArray, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    (orderedDataState: FertilizerProduct[]) =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id
        }))
);

export { selectOptions };
